export default __webpack_public_path__ + "static/media/Habo.b68356e1.svg";